import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import CheckboxField from '@/components/forms/CheckboxField'

import styles from './CheckboxButton.module.scss'

// NOTE: must be rendered within <Form>
const CheckboxButton = ({ name, id, strikePrice, price, smallPrint, disabled, ...rest }) => (
  <CheckboxField
    className={cx('nui-card', styles.box, disabled && styles.disabled)}
    clickableContainer
    disabled={disabled}
    label={
      <>
        <strong className={styles.name}>{name} {strikePrice && <div className={styles.strikePrice}>${strikePrice}</div>} <div className={styles.price}>{price}</div></strong>
        <span className={styles.smallPrint}>{smallPrint}</span>
      </>
  }
    name={id}
    {...rest}
  />
)

CheckboxButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.string,
  strikePrice: PropTypes.number,
  smallPrint: PropTypes.string,
}

export default CheckboxButton
